import { useContext, useEffect, useState } from "react";
import organisms from "../../../components/organisms";
import service from "../../../api/services";
import Wrapper from "../../../components/common/Wrapper/Wrapper";
import { HeaderHeading } from "../../../Context";
import { getDropdown } from "../../../constants/utils";
import { LensDetailsListProps } from "./interface";

const { LensDetails } = organisms;

const Index = () => {
    const [lensDetailsList, setLensDetailsList] = useState<LensDetailsListProps>();
    const [productTypeList, setProductTypeList]=useState<{label:string; value:string}[]>()
    const { setHeader }: any = useContext(HeaderHeading);

    const getLensDetailList = async () => {
        try {
            const response = await service.lensDetails.list();
            setLensDetailsList(response.data);
        } catch (error) { }
    };
    const getProductTypeList = async () => {
        try {
          const response = await service.product.productTypeList({ search: '' })
          if (response.status === 200) {
            const TARGET_NAMES = ["contact lens", "lens"];

            response.data.data = response?.data?.data?.filter((item: any) =>
              TARGET_NAMES.includes(item?.name?.toLowerCase())
            );
            
            setProductTypeList(getDropdown(response.data.data, 'name'))
          }
        } catch (error) {
          console.error('error', error)
        }
      }

    useEffect(() => {
        setHeader("LensDetail");
        getLensDetailList();
        getProductTypeList()
    }, []);

    return (
        <Wrapper>
            <LensDetails
                productTypeListing={lensDetailsList}
                getLensDetailList={getLensDetailList}
                productTypeList={productTypeList}
            />
        </Wrapper>
    );
};

export default Index;
